/* COMPONENT IMPORTS*/
import { GlossaryPopup } from "../../components/Glossary/GlossaryPopup";
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { Highlight } from "../../components/Highlights/Highlight";
import ContextConstructor from "../../components/Context/Context";

/* MODULE IMPORTS */
import Popup from "reactjs-popup";
import React, { Component } from "react";

/* SAME FOLDER IMPORTS*/
import TableSubscriptions from "./TableSubscriptions";
import sendLogError from "../../sendLogError";

/* CSS IMPORT */
import "./Protecao.css";
import "../../components/Loading/loading.css";

//Imagem

import selected from "../../images/selected.png";
import notselected from "../../images/selected.png";
import newseries from "../../images/newseries.png";
import phone from "../../images/phone.png";
import cancel from "../../images/cancel.png";
import continuar from "../../images/continuar.png";
import success from "../../images/success.png";
import confirm from "../../images/confirm.png";
import loading from "../../images/loading.svg";

const pageid = "14597";
var reactPlugin = new ReactPlugin();

class Protecao extends Component {
  static displayName = Protecao.name;

  constructor(props) {
    super(props);
    this.state = {
      protecao: [],
      error: [],
      showFirstPopup: true,
      showSecondPopup: false,
      selectedOption: "",
      loading: true,
      manhaSelected: true,
      tardeSelected: false,
      sortSelect: "Maior Poupança",
    };
  }

  componentDidMount() {
    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.populateProtectionData();
    }
  }

  changePopup() {
    var x = this.state.showFirstPopup;
    this.setState({
      showFirstPopup: !x,
      showSecondPopup: x,
    });
  }

  closeSecondPopup() {
    this.setState({
      showSecondPopup: false,
      manhaSelected: true,
      tardeSelected: false,
    });
  }

  sendContactRequestFunction() {
    if (this.state.manhaSelected) var selectedOption = "Manhã";
    else var selectedOption = "Tarde";
    this.sendContactRequest(selectedOption);
    this.setState({
      manhaSelected: true,
      tardeSelected: false,
    });
  }

  errorLoadingPortfolio() {
    return (
      <div>
        <ErrorPage />
      </div>
    );
  }

  handleOptionChange() {
    this.setState({
      manhaSelected: !this.state.manhaSelected,
      tardeSelected: !this.state.tardeSelected,
    });
  }

  customCheckBoxStructure() {
    var manhaBox = this.state.manhaSelected ? (
      <div className="radiobutton-montepio-selected radiobutton-font">
        <img src={selected} height="26px" width="26px"></img>Manhã
      </div>
    ) : (
      <div
        className="radiobutton-montepio radiobutton-font"
        onClick={() => {
          this.handleOptionChange();
        }}>
        <img src={notselected} height="26px" width="26px"></img>Manhã
      </div>
    );
    var tardeBox = this.state.tardeSelected ? (
      <div
        className="radiobutton-montepio-selected radiobutton-font"
        style={{ marginLeft: "34px" }}>
        <img src={selected} height="26px" width="26px"></img>Tarde
      </div>
    ) : (
      <div
        className="radiobutton-montepio radiobutton-font"
        onClick={() => {
          this.handleOptionChange();
        }}
        style={{ marginLeft: "34px" }}>
        <img src={notselected} height="26px" width="26px"></img>Tarde
      </div>
    );

    return (
      <div
        className="contacto-select-boxes-wrapper"
        style={{ display: "inline-flex", marginBottom: "25px" }}>
        {manhaBox}
        {tardeBox}
      </div>
    );
  }

  popupSubscribe(state) {
    if (!state.showSecondPopup) {
      return (
        <Popup
          trigger={
            <img
              className="create-protection-button"
              src={newseries}></img>
          }
          contentStyle={{ background: "none", border: "none" }}
          modal>
          {(close) => (
            <div className="contact-window">
              <center style={{ marginLeft: "auto", marginRight: "auto" }}>
                <img
                  src={phone}
                  style={{ marginBottom: "33px" }}
                  height="100px"
                  width="100px"></img>
                <div className="contact-window-maintext">
                  Será contactado por um gestor em breve.
                </div>
                <div className="contact-botton-wrapper">
                  <img
                    src={cancel}
                    style={{ cursor: "pointer" }}
                    onClick={close}
                    height="40px"
                    width="165px"></img>
                  <img
                    className="button-continuar"
                    src={continuar}
                    onClick={() => this.changePopup()}
                    style={{ marginLeft: "31px", cursor: "pointer" }}
                    height="40px"
                    width="165px"></img>
                </div>
              </center>
            </div>
          )}
        </Popup>
      );
    }
    if (state.showSecondPopup == true) {
      return (
        <Popup
          trigger={
            <img
              className="create-protection-button"
              src={newseries}></img>
          }
          contentStyle={{ background: "none", border: "none" }}
          modal
          closeOnDocumentClick={false}>
          {(close) => (
            <div className="contact-window-2">
              <center className="center-div-second-popup">
                <img
                  src={success}
                  style={{ marginBottom: "33px" }}
                  height="100px"
                  width="100px"></img>
                <div className="contact-window-maintext">
                  Vamos contactá-lo nas próximas 24 horas. Obrigado.
                </div>
                <div className="contact-window-subtext">
                  Escolha o período em que deseja ser contactado
                </div>
                {this.customCheckBoxStructure()}
                <center className="contact-botton-wrapper">
                  <img
                    src={cancel}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      close();
                      this.closeSecondPopup();
                    }}
                    height="40px"></img>
                  <img
                    className="button-continuar"
                    src={confirm}
                    style={{ marginLeft: "31px", cursor: "pointer" }}
                    onClick={() => {
                      this.sendContactRequestFunction();
                      close();
                      this.closeSecondPopup();
                    }}
                    height="40px"></img>
                </center>
              </center>
            </div>
          )}
        </Popup>
      );
    }
  }

  renderProtectionData(state) {
    return (
      <main className="main">
        <div className="title-bar">
          <div className="title">Proteção</div>
          <div className="title-glossary">
            <GlossaryPopup page="protecao" />
          </div>
        </div>
        <TableSubscriptions protectionList={state.protecao.protection} />
        <div className="card-new-protection">
          <table className="card-new-protection-content">
            <tbody>
              <tr>
                <th className="new-series-title">Subscrição de modalidade</th>
                <th rowSpan="2">{this.popupSubscribe(state)}</th>
              </tr>
              <tr>
                <td className="new-series-subtitle">
                  Agende um contacto para dar seguimento ao processo de subscrição
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="new-protecao-area-mobile">
          <div className="new-protecao-title">Subscrever nova modalidade</div>
          <div className="new-protecao-label">
            Aumente a sua proteção. Indique-nos a modalidade que gostava de subscrever que entramos
            em contacto em 24 horas
          </div>
          <div className="card-new-protection card-new-protection-mobile">
            <div className="card-new-protection-content">
              <div>
                <div className="new-series-title">Subscrição de modalidade</div>
              </div>
              <div>
                <div className="new-series-subtitle">
                  Agende um contacto para dar seguimento ao processo de subscrição
                </div>
              </div>
              <div className="create-protection-button-wrapper">{this.popupSubscribe(state)}</div>
            </div>
          </div>
        </div>
        {/* <Highlight page="protecao" /> */}
      </main>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <div className="main-page-loading">
        <div className="loading">
          <img src={loading}></img>
        </div>
      </div>
    ) : this.state.error ? (
      this.errorLoadingPortfolio()
    ) : (
      this.renderProtectionData(this.state)
    );

    return <div>{contents}</div>;
  }

  async populateProtectionData() {
    try {
      const { idToken, selectedUserID } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        clientId: selectedUserID,
      };

      const response = await fetch("/Portfolio/GetPortfolio", { headers });

      if (!response.ok) {
        this.setState({
          error: false,
          protecao: {},
          loading: false,
        });

        return;
      }

      const data = await response.json();

      this.setState({
        error: false,
        protecao: data || {},
        loading: false,
      });

    } catch (error) {
      console.error("Error fetching protection data:", error);

      this.setState({
        error: true,
        loading: false,
        protecao: {},
      });

      sendLogError(error.message, "populateProtectionData");
    }
  }

  async sendContactRequest(option) {
    try {
      const { idToken, selectedUserID } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
      };

      // obter manager
      let manager = {
        employeeNumber: "",
        email: "Suporte_MyMontepio@montepio.org",
      };

      const resManager = await fetch(
        `/Profile/GetManager?ClientId=${selectedUserID}`,
        { headers }
      );

      if (resManager.ok) {
        const data = await resManager.json();
        manager = data || manager;
      }

      // criar intenção
      const res = await fetch("/Intentions/CreateIntention", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${idToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          IntentionType: "contactrequest_protection",
          EmployeeNumber: manager.employeeNumber,
          EmployeeEmail: manager.email,
          ContactPreference: option,
          ClientID: selectedUserID,
        }),
      });

      if (!res.ok) {
        throw new Error(`Erro HTTP: ${res.status}`);
      }

    } catch (error) {
      console.error("Error sending contact request:", error);

      sendLogError(error.message, "sendContactRequest");

      this.showErrorToast?.("Erro ao enviar pedido de contacto.");
    }
  }
}

Protecao.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Protecao);
